// OSS 图片处理

import { isUndefined, deepExtend } from './lang'

export function ossImageFormat (url, format) {
  return ossImageFormatter(format)(url)
}

export function ossImageFormatter (format) {
  var suffix = createSuffix(format)
  return function _ossImageFormat (url, format2) {
    if (isUndefined(format2)) {
      return url + suffix
    } else {
      return ossImageFormatter(deepExtend({}, format, format2))(url)
    }
  }
}

function createSuffix (format) {
  var processString = ['image']
  for (var f in format) {
    if (format.hasOwnProperty(f)) {
      var childFormat = format[f]
      var formatString = [f]
      if (typeof childFormat === 'string' || typeof childFormat === 'number') {
        formatString.push(childFormat)
      } else {
        for (var p in childFormat) {
          if (childFormat.hasOwnProperty(p)) {
            formatString.push(p + '_' + childFormat[p])
          }
        }
      }
      processString.push(formatString.join(','))
    }
  }
  return '?x-oss-process=' + processString.join('/')
}
